/** Copy of the primary navigation drawer. */
export const PRIMARY_NAV_DRAWER_COPY = {
  label: "Main",
  soon: "Coming soon",
  pin: "Pin menu",
  unpin: "Unpin menu",
  stackLabel: "Tips",
  create: "Create data story",
  capture: { title: "Capture with MagicBI", subtitle: "Chrome extension · save any dashboard" },
  invite: { title: "Invite your team", subtitle: "Stories land in their feed" },
  connect: { title: "Connect a data source", subtitle: "Sharper answers to why" },
} as const;
